import React, {useState} from 'react'
import styled from 'styled-components'
import {Helmet} from 'react-helmet'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'

import {Gradient} from '../styles/styledComps'
import Header from '../components/header'
import config from '../../data/config.json'
import changelog from '../../data/changelog.json'

const Layout = styled.div`
	margin: 0 auto;
	max-width: 1200px;
`

const ChangelogData = styled.div`
	padding: 0 1rem;

	table {
		margin-bottom: 2rem;
		white-space: nowrap;

		td {
			white-space: nowrap;
		}
	}
`

const SelectStyles = {
	container: (styles) => ({...styles, maxWidth: '400px', marginRight: '1rem', marginTop: '1rem', marginBottom: '1rem'}),
	valueContainer: (styles) => ({...styles, paddingLeft: '8px'}),
	menu: (styles) => ({...styles, zIndex: 10})
}

export default ({pageContext}) => {
	const defaultSnapshot = pageContext.changelog ? pageContext.changelog : config.latestSnapshot
	const[data, setData] = useState(changelog.find(e => e.snapshot === defaultSnapshot).data) 
	return(
		<>
			<Gradient />
			<Layout>
				<Header page='changelog' />
				<Helmet title='MPN | Changelog' />
				<ChangelogData>
					<Select components={makeAnimated()} placeholder="Select Snapshot..." styles={SelectStyles}
						// Note: The slice() is to remove the first snapshot.  This
						// relies on allSnapshots in config.json being ordered from
						// earliest to latest.
						options={[...config.allSnapshots].slice(1).reverse()
							 .map(date => ({value: date, label: date}))}
						defaultValue={{value: defaultSnapshot, label: defaultSnapshot}}
						onChange={(date) => setData(changelog.find(e => e.snapshot === date.value).data)}
					/>
					<div style={{overflowX: 'scroll'}}>
						<table>
						<thead>
							<tr><th>Package</th><th>Change</th><th>Previous Version</th><th>New Version</th></tr>
						</thead>
						<tbody>	
							{data.length > 0 && data.map((pkg, i) => (
								<tr key={i}>
									<td>{pkg.Package}</td>
									<td>{pkg.change}</td>
									<td>{pkg.prev_version}</td>
									<td>{pkg.new_version}</td>
								</tr>
								))}
						</tbody>
					</table>
					</div>
				</ChangelogData>
			</Layout>
		</>
	)
}
